export default __webpack_public_path__ + "static/media/screen4.626967d6.png";